import { ChangeDetectionStrategy, Component } from '@angular/core'


@Component({
  selector: 'lib-hyperkit',
  imports: [],
  templateUrl: './hyperkit.component.html',
  styleUrl: './hyperkit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HyperkitComponent {}
